<template>
  <div class="modal-detailpo">
    <Email v-if="$store.state.modalStore.showModalEmailPo" />
    <EmailPreview v-if="$store.state.modalStore.showPoEmailPreview" />
    <div class="mdp-wrapper">
      <div class="mdp-event-title">PERIODE PO</div>
      <div class="mdp-radio" v-for="(item, index) in filters" :key="index">
        <label class="mr20" :for="item.value">
          <input
            class="mr5"
            type="radio"
            :value="item.value"
            name="PERIODE PO"
            v-model="choosePeriodeKinerjaPO"
          />
          {{ item.name }}
        </label>
      </div>
    </div>
    <div class="custom-total-event">
      <div class="text-danger text-bold">Kostum</div>
      <div class="input-wrap">
        <input type="date" v-model="kinerjaPoStartDate" />
      </div>
      <div>s/d</div>
      <div class="input-wrap">
        <input type="date" v-model="kinerjaPoEndDate" />
      </div>
      <div @click="runCustomDate()">
        <strong class="search-icons"><i class="fas fa-search"></i></strong>
      </div>
    </div>
    <div v-show="chartPo">
      <ChartKinerjaPO :chartData="chartData" :options="options" :height="275" />
    </div>
    <div class="kinerjapo-list-wrapper" v-if="detailPo">
      <div class="kinerjapo-list kinerjapo-title">
        <div class="kinerjapo-list__no">No</div>
        <div class="kinerjapo-list__nomorpo">Nomor PO</div>
        <div
          class="kinerjapo-list__po-date"
          style="cursor:pointer"
          @click="orderByDate()"
        >
          Tanggal PO
          <i
            class="fas fa-sort-numeric-down-alt"
            v-show="$store.state.level1.detailPoOrder == 'desc'"
          ></i
          ><i
            class="fas fa-sort-numeric-up"
            v-show="$store.state.level1.detailPoOrder == 'asc'"
          ></i>
        </div>
        <div
          class="kinerjapo-list__value"
          v-if="$get($store, 'state.permissions.60.allow')"
        >
          Nilai PO
        </div>
        <div class="kinerjapo-list__avg ">Nilai Rata-Rata</div>
        <div class="kinerjapo-list__qty">GR Kuantitas</div>
        <div class="kinerjapo-list__desc">Keterangan</div>
        <div class="kinerja-list__send-mail"></div>
      </div>
      <div
        class="kinerjapo-list"
        v-for="(list, index) in detailPo"
        :key="index"
      >
        <div class="kinerjapo-list__no">{{ index + 1 }}</div>
        <div class="kinerjapo-list__nomorpo">{{ list.PO_NUMBER }}</div>
        <div class="kinerjapo-list__po-date">
          {{ formatDate(list.PO_DATE) }}
        </div>
        <div
          class="kinerjapo-list__value"
          v-if="$get($store, 'state.permissions.60.allow')"
        >
          {{ curencyDelimiter(list.VALUE_PER_UNIT_IDR) }}
        </div>
        <div class="kinerjapo-list__avg ">
          {{ curencyDelimiter(list.CSI_SCORE_AVG) }}
        </div>
        <div class="kinerjapo-list__qty">
          {{ curencyDelimiter(list.CSI_QUANTITY) }}
        </div>
        <div class="kinerjapo-list__desc">
          {{ csiCategory(list.CSI_SCORE_AVG) }}
        </div>
        <div
          class="kinerjapo-list__send-mail text-center"
          @click="sendMail(list)"
          v-if="$get($store, 'state.permissions.56.allow')"
        >
          <i class="far fa-envelope"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from 'numeral'
export default {
  name: 'KinerjaPO',
  props: {
    detailId: {
      type: String,
      required: false, // true if api ready
    },
  },
  components: {
    Email: () => import('@/components/poEmail'),
    EmailPreview: () => import('@/components/modal/emailPreviewPo'),
    ChartKinerjaPO: () => import('@/components/chart/Chart'),
  },
  data() {
    return {
      sortMode: false,
      filters: [
        {
          name: '3 Bulan',
          value: '3',
        },
        {
          name: '6 Bulan',
          value: '6',
        },
        {
          name: '12 Bulan',
          value: '12',
        },
      ],
      currentPage: 1,
      totalPerPage: 20,
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        title: {
          display: true,
          text: 'Kinerja PO',
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return label
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  let idr = numeral(value).format('0,0.00')
                  let newIdr = ''
                  idr.split('').map(list => {
                    if (list == ',') {
                      newIdr += '.'
                    } else if (list == '.') {
                      newIdr += ','
                    } else {
                      newIdr += list
                    }
                  })
                  return newIdr
                },
              },
            },
            {
              id: 'B',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  let idr = numeral(value).format('0,0.00')
                  let newIdr = ''
                  idr.split('').map(list => {
                    if (list == ',') {
                      newIdr += '.'
                    } else if (list == '.') {
                      newIdr += ','
                    } else {
                      newIdr += list
                    }
                  })
                  return newIdr
                },
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    chartPo: function() {
      this.chartUpdate()
      return this.$store.state.level1.chartPo
      // this.chartCategories()
      // this.seriesData()
      // this.seriesData2()
    },
    detailPo: function() {
      return this.$store.state.level1.detailPo
    },
    choosePeriodeKinerjaPO: {
      get: function() {
        return this.$store.state.searchStore.choosePeriodeKinerjaPO
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodeKinerjaPO',
          value: newValue,
        })

        let query = {
          poStart: `${this.monthFromNow(newValue)}`,
          poEnd: `${this.$now()}`,
        }

        await this.$store.commit('level1/CUSTOM_KINERJA_PO', query)
      },
    },
    kinerjaPoStartDate: {
      get: function() {
        return this.$store.state.searchStore.kinerjaPoStartDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoStartDate',
          value: newValue,
        })
      },
    },
    kinerjaPoEndDate: {
      get: function() {
        return this.$store.state.searchStore.kinerjaPoEndDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoEndDate',
          value: newValue,
        })
      },
    },
  },
  methods: {
    async runCustomDate() {
      const query = {
        poStart: `${this.kinerjaPoStartDate}`,
        poEnd: `${this.kinerjaPoEndDate}`,
      }

      await this.$store.commit('level1/CUSTOM_KINERJA_PO', query)
    },
    orderByDate() {
      this.$store.commit('level1/ORDER_KINERJA_PO')
    },
    mergeSameValue(value) {
      return value
    },
    chartUpdate() {
      const self = this
      const chart = self.$store.state.level1.chartPo
      let customCategories = []
      let categories = []
      let series1 = []
      let series2 = []

      if (chart) {
        for (let i in chart) {
          categories.push(
            `${this.monthConverter(chart[i].month)} '${this.twoDigitYear(
              chart[i].year
            )}`
          )
          if (this.$get(this.$store, 'state.permissions.60.allow')) {
            series1.push(this.convertNumberDescimal(chart[i].total_value_idr))
          }
          series2.push(this.convertNumberDescimal(chart[i].csi_score_avg))
        }

        this.chartData = {
          labels: categories,
          datasets: [
            {
              label: 'Nilai IDR',
              backgroundColor: '#990000',
              data: series1,
              yAxisID: 'A',
              order: 2,
            },
            {
              label: 'Nilai Rata-Rata',
              backgroundColor: '#ff9900',
              borderColor: '#ff9900',
              fill: false,
              lineTension: 0,
              data: series2,
              type: 'line',
              yAxisID: 'B',
              order: 1,
            },
          ],
        }
      }
    },
    chartCategories() {
      const self = this
      const csi = self.$store.state.level1.detailPo
      const dateFormat = { day: 'numeric', month: 'short', year: 'numeric' }
      let arr = []
      if (csi) {
        for (let i in csi) {
          arr.push(csi[i].PO_NUMBER)
        }

        self.chartOptions.xaxis.categories = arr
      } else {
        self.chartOptions.xaxis.categories = arr
      }
    },
    seriesData() {
      const self = this
      const csi = self.$store.state.level1.detailPo
      let arr = []
      if (csi) {
        for (let i in csi) {
          arr.push(this.convertNumberDescimal(csi[i].CSI_SCORE_AVG))
        }
        self.series[0].data = arr
      } else {
        self.series[0].data = [
          {
            name: 'Nilai Rata-Rata',
            type: 'line',
            data: [],
          },
        ]
      }
    },
    seriesData2() {
      const self = this
      const csi = self.$store.state.level1.detailPo
      let arr = []
      if (csi) {
        for (let i in csi) {
          arr.push(this.convertNumberDescimal(csi[i].VALUE_PER_UNIT_IDR))
        }
        self.series[1].data = arr
      } else {
        self.series[1].data = [
          {
            name: 'Nilai PO',
            type: 'column',
            data: [],
          },
        ]
      }
    },
    sendMail(list) {
      this.$store.commit('modalStore/SET_DATA_EMAIL_PO', list)
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/csiScoring.scss';
</style>
